import { useStaticQuery, graphql } from "gatsby"

const useSiteUrl = () => {
  const { sitePlugin } = useStaticQuery(graphql`
    query SiteUrlQuery {
      sitePlugin(name: { eq: "gatsby-theme-gba" }) {
        pluginOptions
      }
    }
  `)

  return sitePlugin.pluginOptions.siteUrl
}

export { useSiteUrl }
